<template>
  <footer class="footer">
    <div class="container">
      <ul class="nav nav-pills nav-justified">
        <li class="nav-item">
          <a
            class="nav-link text-white"
            @click="gotoRoute('/login')"
            href="javascript:void(0)"
          >
            <span class="text-nowrap">
              <img
                src="/static/img/landing/privacy.png"
                alt=""
                style="height: 30px;"
                class="img-fluid mx-auto"
              />
              <p class="size-13">เข้าสู่ระบบ</p>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link text-white"
            @click="gotoRoute('/register')"
            href="javascript:void(0)"
          >
            <span class="text-nowrap">
              <img
                src="/static/img/landing/gambler.png"
                alt=""
                style="height: 30px;"
                class="img-fluid mx-auto"
              />
              <p class="size-13">สมัครสมาชิก</p>
            </span>
          </a>
        </li>
        <li class="nav-item centerbutton">
          <a
            @click="gotoRoute('/login')"
            href="javascript:void(0)"
            class="nav-link mb-0"
          >
            <span
              class="theme-radial-gradient shadow-sm shadow-golds text-nowrap"
            >
              <img
                src="/static/img/landing/jackpot.png"
                alt=""
                style="height: 45px;"
                class="pulse2"
              />
              <p class="size-1rem text-white">เข้าเกมส์</p>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link text-white"
            @click="gotoRoute('/free_credit')"
            href="javascript:void(0)"
          >
            <span class="text-nowrap">
              <img
                src="/static/img/landing/gift.png"
                alt=""
                style="height: 30px;"
                class="img-fluid mx-auto wobble-top"
              />
              <p class="size-13">เครดิตฟรี</p>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link text-white"
            @click="gotoRoute('/promotion')"
            href="javascript:void(0)"
          >
            <span class="text-nowrap">
              <img
                src="/static/img/landing/black-friday.png"
                alt=""
                style="height: 30px;"
                class="img-fluid mx-auto"
              />
              <p class="size-13">โปรโมชั่น</p>
            </span>
          </a>
        </li>
      </ul>
    </div>
    <a
      target="_blank"
      href="https://lin.ee/TG72KVu"
      class="position-absolute z-index-1 d-none d-lg-block"
      style="bottom: 120% !important; right: 1% !important;"
    >
      <img
        src="/static/img/landing/line.png"
        alt=""
        style="height: 50px;"
        class="img-fluid mx-auto"
      />
    </a>
    <a
      target="_blank"
      href="https://lin.ee/TG72KVu"
      class="position-absolute z-index-1 d-lg-none d-md-none"
      style="bottom: 120% !important; right: 2% !important;"
    >
      <img
        src="/static/img/landing/line.png"
        alt=""
        style="height: 50px;"
        class="img-fluid mx-auto"
      />
    </a>
  </footer>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import CashBackForm from "@/components/form/CashBackForm";
import PromotionForm from "@/components/form/PromotionForm";
import WheelForm from "@/components/form/WheelForm";
import AfForm from "@/components/form/AfForm";
import WithdrawForm from "@/components/form/WithdrawForm";
import DepositForm from "@/components/form/DepositForm";
import HistoryForm from "@/components/form/HistoryForm";
import ProfileForm from "@/components/form/ProfileForm";
import MemberCard from "@/components/form/MemberCard";
export default {
  name: "Footer",
  data() {
    return {
      isShowNav: true,
      nowPage: this.$route.name,
    };
  },
  components: {
    CashBackForm,
    PromotionForm,
    WheelForm,
    AfForm,
    WithdrawForm,
    DepositForm,
    HistoryForm,
    ProfileForm,
    MemberCard,
  },
  computed: {
    ...mapGetters(["getLineId", "appTitle"]),
  },
  methods: {
    ...mapActions(["userSignIn", "setError"]),
    gotoRoute(route) {
      this.$router.push(route);
    },
  },
  watch: {
    $route() {
      this.nowPage = this.$route.name;
      this.isShowNav = true;
      if (
        this.$route.name == "Login" ||
        this.$route.name == "Profile" ||
        this.$route.name == "Signup" ||
        this.$route.name == "Join"
      ) {
        return (this.isShowNav = false);
      }
    },
  },
  mounted() {
    this.nowPage = this.$route.name;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue